import { createSlice } from '@reduxjs/toolkit';
import { updatePatientPageReducer } from './reducers/update-patient-page.reducer';
import { updatePatientDoctorReducer } from './reducers/update-patient-doctor.reducer';
import { updatePatientRegistrationReducer } from './reducers/update-patient-registration.reducer';
import { updatePatientPrescriptionReducer } from './reducers/update-patient-prescription.reducer';
import { updatePatientPlanReducer } from './reducers/update-patient-plan.reducer';
import { updatePatientAddressReducer } from './reducers/update-patient-address.reducer';
import { initialPatientState } from './state';

export const patientSlice = createSlice({
  name: 'Patient',
  initialState: initialPatientState,
  reducers: {
    updatePage: updatePatientPageReducer,
    updateDoctor: updatePatientDoctorReducer,
    updateRegistration: updatePatientRegistrationReducer,
    updatePrescription: updatePatientPrescriptionReducer,
    updatePlan: updatePatientPlanReducer,
    updateAddress: updatePatientAddressReducer,
  },
});

export const patientSliceReducer = patientSlice.reducer;
